import React, { Component } from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";

import * as invoiceActions from "../../../../../actions/invoice.actions";

import EditInvoice from "../components/EditInvoice";

class EditInvoiceContainer extends Component {
  constructor(props) {
    super(props);

    this.downloadInvoice = this.downloadInvoice.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  downloadInvoice(invoiceId) {
    this.props.invoiceActions.downloadInvoice(invoiceId);
  }

  handleSubmit(data) {
    this.props.invoiceActions.updateInvoice(data);
  }

  render() {
    const invoiceId = this.props.match.params.invoiceId;

    return (
      <EditInvoice
        invoiceId={invoiceId}
        downloadInvoice={this.downloadInvoice}
        onSubmit={this.handleSubmit}
      />
    );
  }
}

const mapStateToProps = () => {
  return {};
};

const mapDispatchToProps = dispatch => ({
  invoiceActions: bindActionCreators(invoiceActions, dispatch)
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(EditInvoiceContainer);



// WEBPACK FOOTER //
// ./src/routes/admin/invoice/edit/containers/EditInvoiceContainer.js